import axios from "axios";


const performOperatorBreakRequest= async (p_relevantUrl ,p_id, p_activate) => {
    
    try {
        let performOperatorBreakResponse = await axios.post(p_relevantUrl + '/admin/operator_break', {id: p_id, activate: p_activate})
            if(performOperatorBreakResponse.status === 200){
                return performOperatorBreakResponse.data;
            }
            return 'error';
    } catch (error) {
        console.log("error While performOperatorBreak: " ,error);
        return 'error';
    }
    
}

export default performOperatorBreakRequest ;